// extracted by mini-css-extract-plugin
export default {"products":"Products_products__tv0Dc","products__title":"Products_products__title__W6aTH","products__list":"Products_products__list__yp0fn"};